import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EntertainmentTimesService {
  OBPortalSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public getEntertainmentTimes(
    evtCode: string | undefined,
    asofdate: string | undefined
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const EntertainmenttimesInfo: JSON = <JSON>(<unknown>{
      evtCode: evtCode,
      asofdate: asofdate,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetEntertainmentTimes',
      JSON.stringify(EntertainmenttimesInfo),
      { headers: headers }
    );
  }
}
